export default "__VITE_ASSET__wCQd1OBq__"